import { render, staticRenderFns } from "./DivaltoCodeUpdate.vue?vue&type=template&id=8e37ff72"
import script from "./DivaltoCodeUpdate.vue?vue&type=script&lang=js"
export * from "./DivaltoCodeUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports